<template>
  <div class="qrcode-container" @click="handleClose">
    <div class="box" :style="currentStyle" @click.stop>
      <img src="../../assets/img/ajeeyoo.png" alt="" @click.stop />
      <van-radio-group
        :value="checked"
        checked-color="#CDA65E"
        icon-size="17px"
      >
        <van-radio name="1" @click.stop="handleChange">今日不再提醒</van-radio>
      </van-radio-group>
      <van-icon
        class="close-icon"
        size="30"
        color="#f5f5f5"
        name="close"
        @click="handleClose"
      />
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { px2rem } from "@/utils/util";
// import Cookies from "js-cookie";

export default {
  data() {
    return {
      checked: undefined,
      currentStyle: {
        width: px2rem(440),
        height: px2rem(440),
      },
    };
  },
  mounted() {
    // 获取屏幕高度和高度，如何宽度大于高度，图片高度需要小一点
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (width > height) {
      this.currentStyle.width = "auto";
      this.currentStyle.height = "60%";
    }
  },
  methods: {
    handleChange() {
      if (this.checked) {
        this.checked = undefined;
      } else {
        this.checked = "1";
      }
    },
    handleClose() {
      const today = dayjs().valueOf();
      if (this.checked) {
        localStorage.setItem("noRemind", today);
        // Cookies.set("noRemind", today);
      }
      sessionStorage.setItem("noRemind", today);
      // const today = dayjs().valueOf();
      // localStorage.setItem("noRemind", today);
      this.$emit("close");
    },
  },
};
</script>
<style lang="less" scoped>
.qrcode-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    // width: 220px;
    // height: 220px;
    // background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    img {
      width: 100%;
      height: 100%;
      margin-bottom: 8px;
    }
    .close-icon {
      position: absolute;
      top: -24px;
      right: -24px;
    }
    /deep/.van-radio__label {
      color: #f5f5f5;
      font-size: 13px;
    }
  }
}
</style>
